import BaseEnumType from "../../common/base-enum-type";

const PatType = Object.freeze({
    KICK: new BaseEnumType("K", "KICK"),
    RUSH: new BaseEnumType("R", "RUSH"),
    PASS: new BaseEnumType("P", "PASS"),
    DROP_KICK: new BaseEnumType("D", "DROP_KICK")
});

export default PatType;
